export class ChangeLocale {
  constructor(lang) {
    this.lang = lang;
  }
}
